// extracted by css-extract-rspack-plugin
export default {"wrapper":"pMK0d003Tg44Oo7J","content":"GlVOPq7jh9caivV_"};